import i18n from 'modules/core/lib/i18n'
import type { RestDayGridEvent } from 'modules/shift_management/utils/TimeGridTable/transformEvents'

import type { EventCardSpec } from 'modules/shift_management/utils/TimeGridTable/resolveCard'

const RestDayCard: EventCardSpec<RestDayGridEvent> = {
  getAppearance: (event) => ({
    background: event.isDraft ? 'grey000White' : 'fuchsia200',
    opacity: '0.9',
    border: {
      all: {
        width: 's1',
        style: event.isDraft ? 'dashed' : 'solid',
        color: event.isDraft ? 'fuchsia1000' : 'grey800',
      },
    },
  }),
  render: () => i18n.t('shift_management.cells.rest_day.title'),
}

export { RestDayCard }
